import { DefaultState, Filters } from 'store/types';

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';


export interface GetUsersParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  },
  sorting: {
    id: string;
    order: string;
  }
}

export interface UserBaseData {
  id: string;
  email: string;
  role: string;
  status: string;
}

export interface GetUsersRow extends UserBaseData {
  fullName: string;
  dateCreated: string;
  dateUpdated: string;
}

export interface GetUserRow extends UserBaseData {
  firstName: string;
  lastName: string;
}

export interface GetUsersData {
  rows: GetUsersRow[];
  totalCount: number;
}

export interface GetUserEmail {
  email: string;
}

export type GetUsersState = DefaultState & {
  contents?: GetUsersData;
};

interface GetUsersRequest {
  type: typeof GET_USERS_REQUEST;
}

interface GetUsersSuccess {
  type: typeof GET_USERS_SUCCESS;
  contents: GetUsersData;
}

interface GetUsersFailure {
  type: typeof GET_USERS_FAILURE;
}

export type GetUsersActionTypes = GetUsersRequest | GetUsersSuccess | GetUsersFailure;